import { useEffect } from 'react';
import { API_BASE_URL } from '../api/client';

declare global {
  interface Window {
    NeuroEdgeChat?: { destroy: () => void };
  }
}

/**
 * Our own website chat (ADR-038) on public pages: the platform workspace's
 * website chat, loaded with the same snippet tenants use (/widget.js). Does
 * nothing when no website chat is set up there. Removed on leaving the page.
 */
export function usePlatformChat(): void {
  useEffect(() => {
    let cancelled = false;
    let script: HTMLScriptElement | null = null;
    fetch(`${API_BASE_URL}/public/webchat/platform`)
      .then((res) => (res.ok ? res.json() : null))
      .then((json: { data?: { siteKey?: string } } | null) => {
        const siteKey = json?.data?.siteKey;
        if (cancelled || !siteKey || window.NeuroEdgeChat) return;
        script = document.createElement('script');
        script.src = '/widget.js';
        script.async = true;
        script.dataset.key = siteKey;
        document.body.appendChild(script);
      })
      .catch(() => {
        // No chat on our site is fine - the enquiry form and contact details remain.
      });
    return () => {
      cancelled = true;
      window.NeuroEdgeChat?.destroy();
      script?.remove();
    };
  }, []);
}
